import { FC } from 'react';

interface AlignLeftIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const AlignLeftIcon: FC<AlignLeftIconProps> = ({ color = 'currentColor', size = '16', className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M1.59844 2.4L14.3984 2.4M1.59844 5.86667L11.0145 5.86667M1.59844 9.33333L14.3984 9.33333M1.59844 12.8L8.43982 12.8"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
